import { FC } from 'react';
import { DataCellProps } from '../types';

export const TeamMemberAccountIdCell: FC<DataCellProps> = ({ _customRowProps, member }) => {
  return <div>{member.account_id}</div>;
};
